export default {
    window: window,
    document: document,
};
